import { ServerClient } from 'common/utils/http/http-clients';
import { IFastAccessPassRead } from './fast-access-service.types';

class FastAccessService {
  async getFastAccessPass(id: string): Promise<IFastAccessPassRead> {
    const res = await ServerClient.get<IFastAccessPassRead>(`/eiq-passport/${id}`);
    return res?.data;
  }
  async obtainGuestFastAccessPass(guestId: number): Promise<string> {
    const res = await ServerClient.post<{ id: string }>('/eiq-passport/guest', { guestId: guestId });
    return res.data.id;
  }
}

export const fastAccessService = new FastAccessService();
export default fastAccessService;
